import { Suspense } from "react";
import { Route, Routes } from "react-router";
import { useTypedParams } from "react-router-typesafe-routes";
import { PageLoading } from "~/components/loading";
import { v2Route } from "~/v2/routes";
import { GeoItemDetail } from "./components/GeoItemDetail";
import { GeoItemsContainer } from "./components/geoItems.container";

function GeoItemDetailRoute() {
  const { id = "" } = useTypedParams(v2Route.geoItems.detail);
  return <GeoItemDetail key={id} id={id} />;
}

export function GeoItemsRoutes() {
  return (
    <Suspense fallback={<PageLoading />}>
      <Routes>
        <Route index element={<GeoItemsContainer />} />
        <Route path=":id" element={<GeoItemDetailRoute />} />
      </Routes>
    </Suspense>
  );
}
